import React from 'react';
import { Link } from 'gatsby';
import { ReactComponent as Logo } from '../assets/icons/logo-dark.svg';
import * as styles from '@/css/footer.module.css';

const Footer = () => {
  return (
    <footer
      className={`text-sm text-white border-none font-body bg-dark py-14 ${styles.footer}`}
    >
      <div className="container">
        <div className="justify-between lg:items-center lg:flex">
          <div className="w-48 h-12">
            <Logo />
          </div>

          <ul className="mt-12 md:flex lg:mt-0">

            <li className="mt-2 md:mr-7 md:mt-0">
              <a href="/platform">Platform</a>
            </li>
            <li className="mt-2 md:mr-7 md:mt-0">
              <a href="/pricing">Pricing</a>
            </li>
            <li className="mt-2 md:mr-7 md:mt-0">
              <a href="/blog">Blog</a>
            </li>
            <li className="mt-2 md:mr-7 md:mt-0">
              <a href="/free-trial">Try Predibase</a>
            </li>
            <li className="mt-2 md:mr-7 md:mt-0">
              <a href="https://app.predibase.com/">Sign In</a>
            </li>
            <li className="mt-2 md:mr-7 md:mt-0">
              <a href="/request-a-demo">Request Demo</a>
            </li>
            <li className="mt-2 md:mr-7 md:mt-0">
              <Link to="/contact-us">Contact Us</Link>
            </li>
            <li className="mt-2 md:mt-0">
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
          </ul>
        </div>

        <div className="flex flex-col md:flex-row md:mt-20 xl:mt-28 md:justify-between">
          <div className="mt-12 md:mt-0 md:flex">
            <p className="md:pr-7">
              <span className="text-white opacity-60">
                All Rights Reserved.
              </span>{' '}
              <span>Predibase 2024</span>
            </p>
          </div>

          <ul className="flex order-first mt-28 md:order-last md:mt-0 -mx-4">
            <li className="px-4 w-auto">
              <a
                href="https://twitter.com/predibase"
                target="_blank">Twitter</a>
            </li>
            <li className='px-4 w-auto'>
              <a
                href="https://www.linkedin.com/company/predibase"
                target="_blank">LinkedIn</a>
            </li>
            <li className='px-4 w-auto'>
              <a
                href="https://github.com/ludwig-ai/ludwig"
                target="_blank">Github</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
